<div class="container-fluid">
    <nav class="navbar sticky-top">
        <div class="d-grid gap-2 d-flex navbar-brand">
            <h2 class="me-md-0 me-4 mobileHeading">Help Desk Tickets</h2>
        </div>
    </nav>
    <div class="row py-1">
        <div class="col-lg-4 rounded-2 ticket-list"
        *ngIf="reports && reports.length != 0">
            <app-report-list [reportList]="reports" [isLoading]="isLoading" (selectReport)="getSelectedReport($event)" (refreshBugReport)="getBugReport()">
            </app-report-list>
        </div>
        <div class="overflow-auto ticket-form" [ngClass]="!reports || reports.length == 0 ? 'col-lg-12': 'col-lg-8'">
            <app-report-form [bugReport]="selectedReport" (newTicketEmit)="newTicket()"></app-report-form>
        </div>
    </div>
</div>
